import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './TradeBook.css';

export default class TradeBook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assetsLoaded: false,
            orders: []
        };
    }

    componentDidMount() {
        const url = 'https://wealthmcx.com/Rest5/my_trades_api/' + localStorage.getItem('userid');
        fetch(url)
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({ orders: responseJson, spinner: false });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        return (
            <div className="trade-book-container">
                

                <div className="trade-list">
                    {this.state.orders.length > 0 ? (
                        this.state.orders.map((trade, index) => (
                            <div className={`trade-card ${trade.pro_loss >= 0 ? 'profit' : 'loss'}`} key={index}>
                                <div className="trade-meta">
                                    <span className={`trade-type ${trade.type.toLowerCase()}`}>
                                        {trade.type.toUpperCase()}
                                    </span>
                                    <span className="trade-date">
                                        <i className="far fa-calendar-alt"></i> {trade.bsday}
                                    </span>
                                </div>

                                <div className="trade-content">
                                    <div className="trade-asset">
                                        <h3>{trade.metal}</h3>
                                        <small>{trade.lotsize} lots</small>
                                    </div>

                                    <div className="trade-stats">
                                        <div className="stat-item">
                                            <small>LTP</small>
                                            <h4>₹{trade.last_live}</h4>
                                            <small>Limit</small>
                                            <h4>₹{trade.setlimit}</h4>
                                        </div>
                                        <div className="stat-item">
                                            <small>P&L</small>
                                            <h4 className={trade.pro_loss >= 0 ? 'text-success' : 'text-danger'}>
                                                ₹{trade.pro_loss}
                                                {trade.pro_loss >= 0 ? (
                                                    <i className="fa fa-arrow-up profit-arrow"></i>
                                                ) : (
                                                    <i className="fa fa-arrow-down loss-arrow"></i>
                                                )}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="no-trades">
                            <i className="far fa-folder-open"></i>
                            <p>No trades found</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}